import eng from "../languages/eng";
import heb from "../languages/heb";
import danish from "../languages/dk";
import ar from "../languages/ar";

export const chooseLang = (lang) => {
    switch (lang) {
        case "en":
            return eng();
        case "he":
            return heb();
        case "da":
            return danish();
        case "ar":
            return ar();
        default:
            return eng();
    }
};
